'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { FontWeight } from '../../util/font.js';
import { getTagStyles, TagSizeToIconStyles, TagSize, TagColor, TagRounding } from './constants.js';

const Tag = ({ CustomLeftIcon, CustomRightIcon, LeftIcon, RightIcon, text, tagColor = TagColor.GRAY, size = TagSize.SMALL, fontWeight = FontWeight.MEDIUM, rounding = TagRounding.FULL, hoverable = false, }) => {
    return (jsxs("div", { className: `inline-flex items-center justify-center ${getTagStyles({ tagColor, size, fontWeight, rounding, hoverable })}`, children: [CustomLeftIcon ? (jsx(CustomLeftIcon, { iconClassName: TagSizeToIconStyles[size] })) : LeftIcon ? (jsx(LeftIcon, { className: TagSizeToIconStyles[size] })) : null, jsx("p", { className: "sm:whitespace-nowrap", children: text }), CustomRightIcon ? (jsx(CustomRightIcon, { iconClassName: TagSizeToIconStyles[size] })) : RightIcon ? (jsx(RightIcon, { className: TagSizeToIconStyles[size] })) : null] }));
};

export { Tag };
//# sourceMappingURL=tag.js.map
